import { render, staticRenderFns } from "./addConsultant.vue?vue&type=template&id=25309c3c&scoped=true&"
import script from "./addConsultant.vue?vue&type=script&lang=ts&"
export * from "./addConsultant.vue?vue&type=script&lang=ts&"
import style0 from "./addConsultant.vue?vue&type=style&index=0&id=25309c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25309c3c",
  null
  
)

export default component.exports